import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { OptionMenu } from '@shared/ui-components/options-menu/options-menu.model';

@Directive({
  selector: '[acOptionsMenu]',
  standalone: true,
})
export class OptionsMenuDirective<MenuItem> {
  @Input({ required: true, alias: 'acOptionsMenu' }) options!: OptionMenu<MenuItem>[];
  @Output() actionExec = new EventEmitter<string>();
}
